export default __webpack_public_path__ + "static/media/logo.8f7a1351.png";